import React from "react"

import { CourseDetail } from "@interfaces/course"
import { ChildrenProps } from "@interfaces/misc"
import { CourseHeading } from "."
import clsx from "clsx"

interface CourseInfoListProps {
  data: CourseDetail
}

interface InfoBoxProps extends ChildrenProps {
  index: string
}

const InfoBox = ({ children, index }: InfoBoxProps) => {
  return (
    <section key={index} className={clsx("bg-[#F7F7F7] sm:p-9 p-4")}>
      {children}
    </section>
  )
}

const InfoHeading = ({ title }: { title: string }) => {
  return (
    <CourseHeading className="font-semibold sm:text-xl text-sm text-black mb-2.5">
      {title}
    </CourseHeading>
  )
}

const OrderedList = ({ children }: ChildrenProps) => {
  return <ol className="flex flex-col sm:gap-1 gap-1.5 mb-0 sm-only:text-sm">{children}</ol>
}

const List = ({ children }: ChildrenProps) => {
  return <li className="list-disc sm:text-base text-sm">{children}</li>
}

export const CourseInfoList: React.FC<CourseInfoListProps> = ({ data }) => {
  const {
    course_expected,
    course_learning_objectives,
    course_competencies,
    course_study_period,
    course_characteristic_participant,
    course_level,
  } = data

  if (!data) {
    return <></>
  }

  return (
    <>
      {Boolean(course_expected?.length) && (
        <InfoBox index="learn">
          <InfoHeading title="Apa yang akan anda pelajari?" />
          <OrderedList>
            {course_expected.map((ex, i) => (
              <List key={i}>{ex.expected_result}</List>
            ))}
          </OrderedList>
        </InfoBox>
      )}

      {Boolean(course_learning_objectives?.length) && (
        <InfoBox index="objective">
          <InfoHeading title="Tujuan pembelajaran" />
          <OrderedList>
            {course_learning_objectives.map((ex, i) => (
              <List key={i}>{ex.course_learning_objective_title}</List>
            ))}
          </OrderedList>
        </InfoBox>
      )}

      {Boolean(course_competencies?.length) && (
        <InfoBox index="objective">
          <InfoHeading title="Kompetensi Yang Dikembangkan" />
          <OrderedList>
            {course_competencies.map((ex, i) => (
              <List key={i}>{ex.course_competence_title}</List>
            ))}
          </OrderedList>
        </InfoBox>
      )}

      {Boolean(course_study_period?.length) && (
        <InfoBox index="objective">
          <InfoHeading title="Periode Belajar" />
          <div className="sm:text-base text-sm">{course_study_period[0]}</div>
        </InfoBox>
      )}

      {Boolean(course_characteristic_participant?.length) && (
        <InfoBox index="objective">
          <InfoHeading title="Karakteristik Peserta" />
          <OrderedList>
            {course_characteristic_participant.map((ex, i) => (
              <List key={i}>{ex}</List>
            ))}
          </OrderedList>
        </InfoBox>
      )}

      {Boolean(course_level?.length) && (
        <InfoBox index="objective">
          <InfoHeading title="Jenjang" />
          <OrderedList>
            {course_level.map((ex, i) => (
              <List key={i}>{ex}</List>
            ))}
          </OrderedList>
        </InfoBox>
      )}
    </>
  )
}
